module.exports = __webpack_public_path__ + "img/responsiveweb.fc6d0900.jpeg";